import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

export class AppAction_setColors {
  static readonly type = '[App] set colors';
  constructor(public colors: Colors) {}
}

interface Colors {
  spinner_color: string;
  spinner_bg: string;
  scroll_top_bg: string;
}

export interface AppStateModel {
  loading: boolean;
  colors: Colors;
}

@State<AppStateModel>({
  name: 'app',
  defaults: {
    loading: false,
    colors: {
      spinner_bg: 'rgb(18, 20, 49, 0.95)',
      spinner_color: 'rgb(191, 126, 148)',
      scroll_top_bg: '#bf7e94',
    },
  },
})
@Injectable()
export class AppState {
  constructor() {}

  @Selector()
  public static colors({ colors }: AppStateModel): Colors {
    return colors;
  }

  @Selector()
  public static loading({ loading }: AppStateModel): boolean {
    return loading;
  }

  @Action(AppAction_setColors)
  setSpinnerColors({ patchState }: StateContext<AppStateModel>, { colors }: AppAction_setColors) {
    patchState({
      colors,
    });
  }
}
